export default __webpack_public_path__ + "media/images/chefs-1-57a2f2b9c7e62e9c0f7076182a636834.png";